import { useState } from "react";
import { Modal, Button, Form, Spinner } from "react-bootstrap";
import { createPortal } from "react-dom";
import {
  ButtonCustom,
  ContactButtonHref,
  ContactButtonHref2,
} from "../../ui/CustomElements";
import axios from "axios";
import { t } from "i18next";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

const PricingModal = ({ show, handleClose }) => {
  const { t, i18n: { language } } = useTranslation();
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    businessType: "",
    teamSize: "",
    workManagement: "",
    goal: "",
    email: "",
    whatsapp: "",
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    setLoading(true);
    setErrors({});

    try {
      const response = await axios.post("https://api.officely.one/api/v1/access-requests", {
        businessType: formData.businessType,
        teamSize: formData.teamSize,
        workManagement: formData.workManagement,
        goal: formData.goal,
        email: formData.email,
        whatsapp: formData.whatsapp,
      });

      // ✅ Success
      console.log(response.data);

      setSubmitted(true);

      setFormData({
        businessType: "",
        teamSize: "",
        workManagement: "",
        goal: "",
        email: "",
        whatsapp: "",
      });

    } catch (error) {
      // ❌ Validation errors (Laravel 422)
      if (error.response?.status === 422) {
        setErrors(error.response.data.errors);
      } else {
        console.error(error);
        alert("Something went wrong. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleGotit = () => {
    setSubmitted(false);
    handleClose();
  }

  if (!show) return null;

  return createPortal(
    <Modal show={show} onHide={handleClose} centered size="lg">
      {!submitted ? (
        <>
          {/* ================= FORM ================= */}
          <Modal.Header>
            <div className="w-100 d-flex align-items-center justify-content-between">
              <Modal.Title>
                {t("access_request_modal_heading")}
              </Modal.Title>

              <button type="button" className="btn-close m-0" onClick={handleClose}></button>
            </div>
          </Modal.Header>

          <Modal.Body>
            <p className="text-muted mb-4">
              {t("access_request_modal_description")}
            </p>

            <Form onSubmit={handleSubmit}>
              {/* Business Type */}
              <Form.Group className="mb-3">
                <Form.Label>{t("type_of_Business")}</Form.Label>

                <Form.Select
                  name="businessType"
                  value={formData.businessType}
                  onChange={handleChange}
                  required
                >
                  <option value="">{t("select_one")}</option>
                  <option value="company">{t("company")}</option>
                  <option value="office">{t("office")}</option>
                  <option value="freelance_team">{t("freelance_team")}</option>
                  <option value="educational_organization">
                    {t("educational_organization")}
                  </option>
                  <option value="other">{t("other")}</option>
                </Form.Select>
              </Form.Group>

              {/* Team Size */}
              <Form.Group className="mb-3">
                <Form.Label>{t("number_of_team_Members")}</Form.Label>
                <Form.Select
                  name="teamSize"
                  value={formData.teamSize}
                  onChange={handleChange}
                  required
                >
                  <option value="">{t("select_one")}</option>
                  <option>1–5</option>
                  <option>6–10</option>
                  <option>11–50</option>
                  <option>{t("more")}</option>
                </Form.Select>
              </Form.Group>

              {/* Work Management */}
              <Form.Group className="mb-3">
                <Form.Label>{t("how_you_manage_work_currently")}</Form.Label>

                <Form.Select
                  name="workManagement"
                  value={formData.workManagement}
                  onChange={handleChange}
                  required
                >
                  <option value="">{t("select_one")}</option>
                  <option value="whatsapp">{t("whatsApp")}</option>
                  <option value="excel">{t("excel")}</option>
                  <option value="other">{t("other_systems")}</option>
                </Form.Select>
              </Form.Group>

              {/* Goal */}
              <Form.Group className="mb-3">
                <Form.Label>{t("what_your_goal_using_officely")}</Form.Label>
                <Form.Control
                  as="textarea"
                  rows={2}
                  name="goal"
                  placeholder={t("briefly") + "..."}
                  value={formData.goal}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              {/* Email */}
              <Form.Group className="mb-3">
                <Form.Label>{t("email_address")}</Form.Label>
                <Form.Control
                  type="email"
                  name="email"
                  placeholder={t("contact_you_through")}
                  value={formData.email}
                  onChange={handleChange}
                  required
                />
              </Form.Group>

              {/* WhatsApp */}
              <Form.Group className="mb-3">
                <Form.Label>{t("whatsApp_number")}</Form.Label>
                <Form.Control
                  type="text"
                  name="whatsapp"
                  placeholder={t("speed_up_activation")}
                  value={formData.whatsapp}
                  onChange={handleChange}
                />
              </Form.Group>

              {/* Footer */}
              <div className="d-flex justify-content-between align-items-center mt-4">
                <small className="text-muted">
                  {t("your_data_will_not_be_shared")}
                </small>

                <div className="d-flex items-center jusitfy-center gap-3">
                  <button
                    type="button"
                    style={{
                      border: "none",
                      outline: "none",
                      background: "none",
                      padding: "0",
                      margin: "0",
                    }}
                  >
                    <ContactButtonHref2
                      label={t("cancel")}
                      style={{ cursor: "pointer" }}
                      className="logSign logSignDesktop"
                      href="#"
                    />
                  </button>
                  <button
                    type="submit"
                    style={{
                      border: "none",
                      outline: "none",
                      background: "none",
                      padding: "0",
                      margin: "0",
                    }}
                  >
                    {loading ? <p className='loading-btn'><span className='spinner'><Spinner className="custom-spinner" /></span></p> : (
                      <ContactButtonHref
                        className="logSign logSignDesktop"
                        style={{ cursor: "pointer" }}
                        label={"Send"}
                        bg="var(--secondaryColor)"
                        color="var(--white)"
                        href="#"
                      />
                    )}
                  </button>
                </div>
              </div>
            </Form>
          </Modal.Body>
        </>
      ) : (
        <>
          <Modal.Body className="text-center py-5 px-4">
            {/* ✅ Success Icon */}
            <div
              className="d-flex align-items-center justify-content-center mx-auto mb-4"
              style={{
                width: "70px",
                height: "70px",
                borderRadius: "50%",
                backgroundColor: "#e6f4ea",
              }}
            >
              <span style={{ fontSize: "32px", color: "#198754" }}>✓</span>
            </div>

            {/* ✅ Title */}
            <h4 className="fw-bold mb-3">{t("your_request_has_been_received")}</h4>

            {/* ✅ Subtitle */}
            <p className="text-muted mb-3">
              {t("thank_for_your_interest")} <strong>{t("officely")}</strong>.
            </p>

            {/* ✅ Main Message */}
            <p
              className="text-muted mb-4"
              style={{ maxWidth: "500px", margin: "0 auto" }}
            >
              {t("we_reviewing_your_request_and_activate_your_free_trail")}
            </p>

            {/* ✅ Highlight Box */}
            <div
              className="p-3 rounded mb-4"
              style={{
                backgroundColor: "#f8f9fa",
                border: "1px solid #e9ecef",
              }}
            >
              <small className="text-muted">
                <strong>{t("note")}:</strong> {t("officely_is_a_system_configured_to_work_correctly")}
              </small>
            </div>

            {/* ✅ Action Button */}
            <Button
              variant="secondary"
              size="lg"
              onClick={handleGotit}
              className="px-4"
              style={{ background: "var(--secondaryColor)", color: "var(--white)" }}
            >
              {t("got_it")}
            </Button>
          </Modal.Body>
        </>
      )}
    </Modal>,
    document.body,
  );
};

export default PricingModal;
